import { render, staticRenderFns } from "./WalletCashia.vue?vue&type=template&id=d029a45a&scoped=true"
import script from "./WalletCashia.vue?vue&type=script&lang=js"
export * from "./WalletCashia.vue?vue&type=script&lang=js"
import style0 from "./WalletCashia.vue?vue&type=style&index=0&id=d029a45a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d029a45a",
  null
  
)

export default component.exports